import SpinnerComponent from'./spinner.component';// Re-export as both default and named export so both import styles work:
// import Spinner from '../spinner'
// import { Spinner } from '../spinner'
export default SpinnerComponent;export const Spinner=SpinnerComponent;export{default as SpinnerWrap}from'./spinner-wrap.component';